import React, { useState } from 'react'
import { observer } from "mobx-react-lite"

import clsx from 'clsx'
import styles from './InstrumentFilter.module.scss'

import {StyledMenu, StyledMenuItem} from '../../components/StyledMenu'
import StyledPopup from '../../components/StyledPopup'

const InstrumentFilter = ({className, classes, model, instruments}) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleClose = (value) => {
    setAnchorEl(null);
    if (value) {
      model.setInstrument(value)
    }
  }

  const open = Boolean(anchorEl)

  const instrument = model.instrument

  const text = instrument == 'all' ? 'Any Instrument' : instrument;

  return <div className={clsx(styles['root'], className)}>
    <StyledPopup value={text} open={open} handleClick={handleClick} className={clsx(classes.button, instrument == 'all' ? null : styles.active)} />
    <StyledMenu anchorEl={anchorEl} open={open} onClose={() => handleClose(null)}>
      <StyledMenuItem onClick={() => handleClose("all")} selected={instrument == 'all'}>Any Instrument</StyledMenuItem>
      {instruments.map(inst => <StyledMenuItem onClick={() => handleClose(inst)} key={inst} selected={inst == instrument}>{inst}</StyledMenuItem>)}
    </StyledMenu>
  </div>
}

export default observer(InstrumentFilter)